/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export function defineButton(tag, dictionary) {
    var characters = tag.characters;
    var states = {
        up: [],
        over: [],
        down: [],
        hitTest: []
    };
    var i = 0, character;
    while ((character = characters[i++])) {
        var characterItem = dictionary[character.symbolId];
        // The Flash Player ignores references to undefined symbols here. So should we.
        // TODO: What should happen if the symbol gets defined later in the file?
        if (characterItem) {
            var cmd = {
                symbolId: characterItem.id,
                code: 4 /* SwfTagCode.CODE_PLACE_OBJECT */,
                depth: character.depth,
                flags: 0,
                matrix: null,
                cxform: null,
                blendMode: null,
                filters: null
            };
            if (character.filters) {
                cmd.flags |= 256 /* PlaceObjectFlags.HasFilterList */;
                cmd.filters = character.filters;
            }
            if (character.blendMode) {
                cmd.flags |= 512 /* PlaceObjectFlags.HasBlendMode */;
                cmd.blendMode = character.blendMode;
            }
            if (character.matrix) {
                cmd.flags |= 4 /* PlaceObjectFlags.HasMatrix */;
                cmd.matrix = character.matrix;
            }
            if (character.cxform) {
                cmd.flags |= 8 /* PlaceObjectFlags.HasColorTransform */;
                cmd.cxform = character.cxform;
            }
            if (character.flags & 1 /* ButtonCharacterFlags.StateUp */)
                states.up.push(cmd);
            if (character.flags & 2 /* ButtonCharacterFlags.StateOver */)
                states.over.push(cmd);
            if (character.flags & 4 /* ButtonCharacterFlags.StateDown */)
                states.down.push(cmd);
            if (character.flags & 8 /* ButtonCharacterFlags.StateHitTest */)
                states.hitTest.push(cmd);
        }
        else {
            console.log('undefined character in button ' + tag.id);
        }
    }
    var button = {
        type: 'button',
        id: tag.id,
        buttonActions: tag.buttonActions,
        states: states
    };
    return button;
}
